import React, { FC } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import StartRating from "components/StartRating/StartRating";
import { Link } from "react-router-dom";
import BtnLikeIcon from "components/BtnLikeIcon/BtnLikeIcon";
import SaleOffBadge from "components/SaleOffBadge/SaleOffBadge";
import Badge from "shared/Badge/Badge";
import useFetch from "hooks/useFetch";


interface HotelData {
  codigo: string;
  descripcion: string;
  ciudad: string;
  direccion: string;
  precio_por_noche: string;
  cant_lugares: number;
  banios_compartidos: number;
  banios_habitaciones: number;
}

interface HotelImageData {
  hotel_code: string;
  photos: string[];
}

interface StayCardProps {
  className?: string;
  hotel: HotelData;
  hotelImages: HotelImageData[];
  size?: "default" | "small";
  defaultImage: string;
}

const StayCard: FC<StayCardProps> = ({ className = "", hotel, hotelImages, defaultImage, size = "default" }) => {
  
  const { codigo, descripcion, ciudad, direccion, precio_por_noche } = hotel;

  // Buscar imágenes para el hotel actual
  const hotelImage = hotelImages.find((item) => item.hotel_code === codigo);
  const images = hotelImage ? hotelImage.photos : [defaultImage];

  const stayCardHref = (codigo: string) => {
    sessionStorage.removeItem("selected_hotel");
    sessionStorage.removeItem("selected_date");
    sessionStorage.removeItem("total_guests");
    sessionStorage.removeItem("children_guests");
    sessionStorage.removeItem("adults_guests");
    sessionStorage.removeItem("infants_guests");

    sessionStorage.setItem("selected_hotel", codigo);
    
    window.location.href ='/listing-stay-detail?selected_hotel='+codigo;

  };

  return (
    <div className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}`} data-nc-id="StayCard">
      <div className="relative w-full">
        <GallerySlider
          uniqueID={`StayCard_${codigo}`}
          ratioClass="aspect-w-4 aspect-h-3 "
          galleryImgs={images}
          codigo_hotel={codigo}
        />
      </div>
      <Link to={""} onClick={ () => stayCardHref(codigo)}> {/* Debes agregar la lógica para redireccionar al detalle del hotel */}
        <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
          <div className="space-y-2">
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {ciudad} · {hotel.cant_lugares} personas
            </span>
            <div className="flex items-center space-x-2">
              <h2
                className={` font-medium capitalize ${
                  size === "default" ? "text-lg" : "text-base"
                }`}
              >
                <span className="line-clamp-1">{descripcion}</span>
              </h2>
            </div>
            <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
              {size === "default" && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              )}
              <span className="">{direccion}</span>
            </div>
          </div>
          <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div>
          <div className="flex justify-between items-center">
            <span className="text-base font-semibold">
              ${precio_por_noche}
              {size === "default" && (
                <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                  /noche
                </span>
              )}
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default StayCard;